<script setup lang="ts">
import useConsumerPrescriptors from "@/consumer/composables/useConsumerPrescriptors";
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from "@/core/components/ui/select";
import {Stethoscope} from "@lucide/vue";
import {AcceptableValue} from "reka-ui";

const props = defineProps<{
    consumerKey: string;
}>();

const {data, isLoading} = useConsumerPrescriptors(props.consumerKey);

const selected = defineModel<number | null>({
    default: null
});

const handleUpdate = (value: AcceptableValue) => {
    if (value === "-1") {
        selected.value = null;
    } else if (typeof value === "string") {
        selected.value = parseInt(value);
    }
};
</script>

<template>
  <Select
    v-if="!isLoading"
    :value="selected?.toString()"
    @update:model-value="handleUpdate"
  >
    <SelectTrigger class="w-[250px] bg-white">
      <div class="flex gap-2 items-center">
        <Stethoscope class="size-4" />
        <SelectValue placeholder="Filtrer par prescripteur" />
      </div>
    </SelectTrigger>
    <SelectContent class="max-h-[300px]">
      <SelectItem value="-1">
        Tous les prescripteurs
      </SelectItem>
      <SelectItem v-for="prescriptor in (data ?? [])" :key="prescriptor.id" :value="prescriptor.rpps?.toString()">
        {{ prescriptor.name }}
      </SelectItem>
    </SelectContent>
  </Select>
</template>

<style scoped>

</style>
